import { ENDPOINTS } from '../utils/constants';
import request from './HttpService';

type GetActionsParams = {
  task: string;
  lucidId?: string;
  deliveryId?: string;
  salesOrderId?: string;
  reservationNo?: string;
  langCode?: string;
};

export const getActions = async (params: GetActionsParams) => {
  return (await request.post(ENDPOINTS.getActions, params)).data.data || [];
};

export const updateActionStatus = async (actionId: string, status: string) => {
  return (await request.put(ENDPOINTS.updateActionStatus, { actionId, status })).data.data;
};
